module.exports = __webpack_public_path__ + "static/Tungsten-Semibold-86936db0ff48f389ad9906376d315ac9.woff";